module.exports = __webpack_public_path__ + "static/img/gaozhongwuli3.0ef2f581.jpg";